module.exports = __webpack_public_path__ + "img/icon.efdf828.png";